import Vue from "vue";
import App from "./App.vue";

import SecureWebStorage from "secure-web-storage";
import CryptoJS from "crypto-js";

import router from "./route/index";
import store from "./store";
import VeeValidate from "vee-validate";
import axios from "axios";
import AsyncComputed from "vue-async-computed";
import PortalVue from "portal-vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
import "leaflet-fullscreen/dist/Leaflet.fullscreen";
import { addRefreshTokenFlow } from "./refresh-token";
import { jsPDF } from "jspdf";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { i18n,loadTranslations } from "./translateFunction";
// Import Bootstrap an BootstrapVue CSS files (order is important)
import "@/assets/vendors/mdi/css/materialdesignicons.min.css";
import "@/assets/css/style.css";
import "@/assets/css/style-responsive.css";
import "@/assets/css/custom.css";
import "@/assets/css/font-awesome.min.css";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
//dotenv.config()
//import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import VueLazyLoad from "vue-lazyload";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import datePicker from "vue-bootstrap-datetimepicker";
//storage constants
import storage_constants from "./exports/constants";
//remove service worker
///import './registerServiceWorker'
navigator.serviceWorker.getRegistrations().then(function (registrations) {
  for (let registration of registrations) {
    registration.unregister();
  }
});
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(Chartkick.use(Chart));
Vue.config.productionTip = false;
Vue.use(jsPDF);
Vue.use(VueLazyLoad);
Vue.use(PortalVue);
Vue.use(datePicker);
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
Vue.use(VeeValidate, {
  events: "blur",
  inject: true,
  fieldsBagName: "veeFields",
});

//async computed
Vue.use(AsyncComputed);
console.log("storage constants:", storage_constants);
Vue.prototype.$OMSStorageUrl = storage_constants.STORAGE_URL; // process.env.VUE_APP_STORAGE_URL
Vue.prototype.$OMSServersUrl = storage_constants.SERVERS_URL; // process.env.VUE_APP_SERVERS_URL
Vue.prototype.$MediaPrefix = storage_constants.MEDIA_PREFIX;

Vue.prototype.$DEV_URL = storage_constants.DEV_URL;

Vue.prototype.$allowedTypes = [
  "docx",
  "pdf",
  "doc",
  "png",
  "jpg",
  "jpeg",
  "ppt",
  "pptx",
  "xls",
  "xlsx",
  "mp4",
  "txt"
]; //allowed upload filetypes array
Vue.prototype.$maxFileSize = 26214400; //25MB  /// 3145728 //Maximum File Size 3MB
Vue.prototype.$escapeSpecialCharRule = new RegExp(/^[A-Za-z0-9\s&/\\-]+$/); //text input validation
const DefaultApiServer = "http://localhost:8000"; // process.env.VUE_APP_API_SERVER
console.log(DefaultApiServer);
Vue.prototype.$userPermissions = {};

// // rpa types configurables
Vue.prototype.$rpa_types = [
  {
    "key": "bill_payment_vendor",
    "value": "Bill Payment Vendor",
  }
]

// activitiy list refresh timer in miliseconds(ms)
Vue.prototype.$activityListRefreshTime = 10 * 60 * 1000; // 10 minutes in milliseconds

// Placeholder values for initialization
const SECRET_KEY = store.state.SECRET_KEY;

Vue.prototype.$minPasswordLength = 10;
// Initialize $secureStorage first
Vue.prototype.$secureStorage = new SecureWebStorage(localStorage, {
  hash: function hash(key) {
    key = CryptoJS.SHA256(key, SECRET_KEY);

    return key.toString();
  },
  encrypt: function encrypt(data) {
    data = CryptoJS.AES.encrypt(data, SECRET_KEY);

    data = data.toString();

    return data;
  },
  decrypt: function decrypt(data) {
    data = CryptoJS.AES.decrypt(data, SECRET_KEY);

    data = data.toString(CryptoJS.enc.Utf8);

    return data;
  },
});
store.dispatch("getBaseURL")
.then(() => {
  Vue.nextTick(() => {
    axios.defaults.baseURL = store.getters.baseURL || DefaultApiServer;
    // axios.defaults.baseURL = "http://127.0.0.1:8000/api/v1/";
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers.common["X-localization"] =
      localStorage.getItem("language") || "en";
    store.dispatch("getToken");
    store.dispatch("getVersions");

    console.log("baseURL", store.getters.baseURL);

    addRefreshTokenFlow(axios);
    loadTranslations().then(() => {
      new Vue({
        router,
        store,
        render: (h) => h(App),
        i18n,
      }).$mount("#app");
    });
   
  });
});
